import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectLoginUsername,
  selectLookupResponse,
  setLoginError,
  setLoginUsername,
} from '../../../features/login/loginSlice';
import { isHatName } from '../../../utils/Validations';

export const LoginUsernameInput: React.FC = () => {
  const lookupDetails = useSelector(selectLookupResponse);
  const uesrname = useSelector(selectLoginUsername);
  const dispatch = useDispatch();

  return (
    <div className={'url-input-wrapper'}>
      <input
        className="hatters-input login-hat-name-input"
        name={'url'}
        type={'url'}
        placeholder="yourname"
        autoComplete={'username'}
        value={uesrname.username}
        onFocus={() => dispatch(setLoginError({ displayError: false, errorType: '' }))}
        onChange={(e) => dispatch(setLoginUsername({ username: e.target.value, isValid: isHatName(e.target.value) }))}
      />
      <input
        className="hatters-input login-hat-domain-input"
        placeholder={lookupDetails && lookupDetails.hatCluster ? '.' + lookupDetails.hatCluster : '.yourhatdomain'}
        disabled={true}
      />
    </div>
  );
};
